export const setInvoice = (value, page, limit, count) => {
    return {
      type: 'SET_INVOICE',
      payload: { data: value, page, limit, count }
    };
  };